<div class="card p-3">
  <div class="row mb-2">
    <div class="col-md-12">
      <button type="button" class="btn btn-outline-primary btn-sm mr-2" [class.active]="mode=='existing'"
        *ngIf="drivers?.length > 0" (click)="mode='existing'; errorMessage=''">Add Existing Driver</button>
      <button type="button" class="btn btn-outline-primary btn-sm" [class.active]="mode=='new'"
        (click)="mode='new'; errorMessage=''">Add New Driver</button>
    </div>
  </div>

  <div *ngIf="mode=='existing'" class="row mb-2">
    <div class="col-md-6">
      <label>Select Driver</label>
      <select class="form-control" [(ngModel)]="selectedDriverId">
        <option value="">Select</option>
        <option *ngFor="let d of drivers" [value]="d.id">
          {{d.title}} {{d.first_name || 'Driver'}} {{d.last_name}}
        </option>
      </select>
    </div>
    <div class="col-md-6 d-flex align-items-end">
      <button type="button" class="btn btn-primary btn-sm" (click)="selectExistingDriver()">Add</button>
    </div>
  </div>

  <div *ngIf="mode=='new'">
    <div class="row mb-2">
      <div class="col-md-3">
        <label>Title <span class="text-danger">*</span></label>
        <select class="form-control" [(ngModel)]="newDriver.title">
          <option value="">Select</option>
          <option *ngFor="let t of staticData?.title_options" [value]="t">{{t}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <label>Forename(s) <span class="text-danger">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="newDriver.first_name">
      </div>
      <div class="col-md-4">
        <label>Surname <span class="text-danger">*</span></label>
        <input type="text" class="form-control" [(ngModel)]="newDriver.last_name">
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <small>The remaining driver details (date of birth, licence type and licence held since) are collected on
          the Drivers page and must be completed before the quote can be finished.</small>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-md-12">
        <button type="button" class="btn btn-secondary btn-sm mr-2" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary btn-sm" (click)="createNewDriver()" [disabled]="isCreating">
          <span *ngIf="isCreating" class="spinner-border spinner-border-sm mr-1"></span>Create Driver
        </button>
      </div>
    </div>
  </div>

  <div class="invalid-feedback d-block" *ngIf="errorMessage">{{ errorMessage }}</div>
</div>
